import { render, staticRenderFns } from "./PrintTable.vue?vue&type=template&id=5fb240b3"
import script from "./PrintTable.vue?vue&type=script&lang=js"
export * from "./PrintTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports